// extracted by mini-css-extract-plugin
var _1 = "TutorialListModal-module__description--MwYeW";
export { _1 as "description" }
